'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Throttle = exports.throttle = void 0;
var vue_class_component_1 = require("vue-class-component");
/**
 * Execute function only once for specified time interval
 *
 * @param callback Function to be throttled
 * @param waitMs Number of milliseconds of the time interval
 * @param immediate Whether the function should be called immediately or not
 * @see https://gist.github.com/beaucharman/e46b8e4d03ef30480d7f4db5a78498ca
 */
function throttle(callback, waitMs, immediate) {
    if (immediate === void 0) { immediate = true; }
    var timeout = null;
    var initialCall = true;
    return function throttled() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callNow = immediate && initialCall;
        var next = function () {
            callback.apply(_this, args);
            timeout = null;
        };
        if (callNow) {
            initialCall = false;
            next();
        }
        if (!timeout) {
            timeout = window.setTimeout(next, waitMs);
        }
    };
}
exports.throttle = throttle;
function Throttle(delayMs, immediate) {
    if (immediate === void 0) { immediate = true; }
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        var functionToThrottle = options.methods[key];
        if (functionToThrottle && delayMs > 0) {
            options.methods[key] = throttle(functionToThrottle, delayMs, immediate);
        }
    });
}
exports.Throttle = Throttle;
